import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
import { useGetUserDataQuery } from "../../services/login";
function PrivacyPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Privacy policy"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <section>
                  <h1 style={{ fontSize: "1.4rem" }}>Privacy Policy</h1>

                  <p>
                    At TheGlobalGenie.com, your privacy is not just a legal requirement for us, it is a responsibility
                    we take seriously. This Privacy Policy explains in clear terms what information we collect, how we
                    use it, how we protect it, and the choices you have about your data when you visit our website or
                    use our services.
                  </p>

                  <p>By using our website, you agree to the practices described in this policy.</p>

                  <h4>1. Information We Collect</h4>

                  <p>
                    When you interact with our website or app, we may collect two types of information: personal
                    information you share with us and data collected automatically.
                  </p>

                  <h4>1.1 Personal Information</h4>

                  <p>
                    When you register, place an order, subscribe to our newsletters, contact us, or otherwise engage
                    with our services, we may collect details such as:
                  </p>
                  <ul>
                    <li>Your name</li>
                    <li>Shipping and billing address</li>
                    <li>Email address and phone number</li>
                    <li>Payment information</li>
                    <li>Any other information you choose to share while using our services</li>
                  </ul>

                  <h4>1.2 Automatically Collected Data</h4>

                  <p>
                    When you browse our website, certain information is collected automatically to help us understand
                    how our site is used and to improve your experience. This may include:
                  </p>
                  <ul>
                    <li>IP address</li>
                    <li>Browser type and version</li>
                    <li>Device type and operating system</li>
                    <li>Pages visited, time spent, and actions taken on the site</li>
                    <li>Purchase and browsing history</li>
                  </ul>

                  <p>
                    This information is generally collected in aggregated or anonymised form and helps us improve
                    performance, security, and user experience.
                  </p>

                  <h4>1.3 Cookies and Tracking Technologies</h4>

                  <p>We use cookies and similar technologies to:</p>
                  <ul>
                    <li>Remember your preferences and settings</li>
                    <li>Keep you logged in where applicable</li>
                    <li>Analyse site traffic and performance</li>
                    <li>Show you relevant offers and advertisements</li>
                  </ul>

                  <p>
                    You can control or delete cookies through your browser settings. However, disabling certain cookies
                    may affect how some features of the website function.
                  </p>

                  <h4>2. How We Use Your Information</h4>

                  <p>
                    We use the information we collect for purposes that help us deliver and improve our services while
                    respecting your privacy.
                  </p>

                  <ul>
                    <li>
                      <strong>To provide and improve our services:</strong> Process your orders, manage your account,
                      personalise your experience, and improve our website, products, and customer support.
                    </li>
                    <li>
                      <strong>To communicate with you:</strong> Send order confirmations, shipping updates, service
                      notifications, and respond to your queries and requests.
                    </li>
                    <li>
                      <strong>For marketing and promotions:</strong> Share newsletters, special offers, product updates,
                      and event information that we think you may be interested in. You can opt out of these
                      communications at any time.
                    </li>
                    <li>
                      <strong>For legal, security, and compliance purposes:</strong> Comply with applicable laws,
                      prevent fraud and misuse, protect our rights and those of our users, and investigate potential
                      security incidents.
                    </li>
                  </ul>

                  <h4>3. Data Retention</h4>

                  <p>
                    We keep your personal information only for as long as it is needed for the purposes described in
                    this Privacy Policy or as required by law.
                  </p>

                  <p>
                    For example, we may retain certain records for accounting, legal, or tax reasons even after you stop
                    using our services or unsubscribe from marketing communications.
                  </p>

                  <h4>4. Data Security</h4>

                  <p>
                    We use reasonable technical and organisational measures to protect your personal information from
                    unauthorised access, misuse, loss, or disclosure. These measures may include:
                  </p>
                  <ul>
                    <li>
                      Encryption technologies such as SSL (Secure Sockets Layer) for sensitive data (including payment
                      information)
                    </li>
                    <li>Restricted access to personal data on a need-to-know basis</li>
                  </ul>

                  <p>
                    While we do our best to protect your data, no method of transmitting or storing information over the
                    internet can be guaranteed to be 100% secure. Accordingly, we cannot promise absolute security but
                    are committed to continually reviewing and improving our safeguards.
                  </p>

                  <h4>5. Sharing Your Information with Third Parties</h4>

                  <p>
                    We do not sell your personal information. However, we may share your information with trusted third
                    parties when necessary to run our business and deliver our services, such as:
                  </p>
                  <ul>
                    <li>Shipping and logistics partners</li>
                    <li>Payment processors and banks</li>
                    <li>Marketing and email service providers</li>
                    <li>IT and cloud service providers</li>
                  </ul>

                  <p>
                    These partners are required to use your information only for the specific services they provide to
                    us and to protect it in line with applicable laws and our instructions.
                  </p>

                  <h4>6. Third-Party Links and Advertising</h4>

                  <p>
                    Our website may contain links to other websites or services that are not operated by us. If you
                    follow a link to a third-party site, their own privacy policy will apply to any information you
                    share there. We are not responsible for the content, security, or privacy practices of such third
                    parties.
                  </p>

                  <p>
                    We may also work with third-party advertising providers (such as Google AdSense) that use cookies or
                    similar technologies to show you ads based on your past visits to our website or other sites.
                  </p>

                  <h4>7. Your Rights and Choices</h4>

                  <p>You have certain rights and choices regarding how your personal information is handled:</p>
                  <ul>
                    <li>
                      <strong>Access and correction:</strong> You may request a copy of the personal information we hold
                      about you and ask us to correct or update any inaccuracies.
                    </li>
                    <li>
                      <strong>Deletion:</strong> You may request that we delete your personal information where it is no
                      longer needed for the purposes for which it was collected, or where we are not legally required to
                      keep it.
                    </li>
                    <li>
                      <strong>Opting out of marketing:</strong> You can unsubscribe from marketing emails at any time by
                      clicking the “unsubscribe” link in our emails or by contacting us directly. Even if you opt out of
                      marketing, we may still send you non-promotional messages related to your orders or account.
                    </li>
                  </ul>

                  <p>
                    We may need to verify your identity before fulfilling certain requests to protect your privacy and
                    security.
                  </p>

                  <h4>8. Children’s Privacy</h4>

                  <p>
                    Our services are not directed to children under the age of 13, and we do not knowingly collect
                    personal information from them. If we learn that we have unintentionally collected information from
                    a child under 13, we will take steps to delete it as soon as reasonably possible.
                  </p>

                  <h4>9. International Data Transfers</h4>

                  <p>
                    Your information may be stored or processed in countries other than your own, including locations
                    where data protection laws may differ from those in your jurisdiction.
                  </p>

                  <p>
                    By using our website and services, you understand and agree that your information may be transferred
                    to and processed in such countries, subject to appropriate safeguards as required by applicable law.
                  </p>

                  <h4>10. Changes to This Privacy Policy</h4>

                  <p>
                    We may update this Privacy Policy from time to time to reflect changes in our practices,
                    technologies, legal requirements, or for other operational reasons. When we make changes, we will
                    update the “Last Updated” date at the top or bottom of the policy and, where appropriate, notify you
                    through our website or by email.
                  </p>

                  <p>
                    Your continued use of our services after any changes become effective means you accept the updated
                    policy.
                  </p>

                  <h4>11. Contact Us</h4>

                  <p>
                    If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy
                    practices, you can reach us at:
                  </p>

                  <p>
                    <strong>Email:</strong> cs@theglobalgenie.com
                    <br />
                    <strong>Phone:</strong> +91- 9653498993
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
